import { MenuDivider, MenuItem } from '@chakra-ui/react';
import Table, { TCols } from 'components/Table';
import ActionCell from 'components/Table/Cells/ActionCell';
import MembersCell from 'components/Table/Cells/MembersCell';
import RoleCell from 'components/Table/Cells/RoleCell';
import TeamNameCell from 'components/Table/Cells/TeamNameCell';
import React from 'react';
import { BiBarChartAlt2 } from 'react-icons/bi';
import { TbUserPlus } from 'react-icons/tb';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes';
import DeleteTeamDialog from './DeleteTeamDialog';
import EditTeamNameDialog from './EditTeamNameDialog';
import InviteMemberDialog from './InviteMemberDialog';
import { useAppSelector } from 'store/hooks';
import { selectTeams } from 'store/slices/teams';

const TeamTable = () => {
    const teams = useAppSelector(selectTeams);
    const navigate = useNavigate();

    const columns: TCols<{ value: any; row: (typeof teams)[number] }> = React.useMemo(
        () => [
            {
                field: 'title',
                headerName: 'Team',
                flex: 1,
                minWidth: 100,
                renderCell: ({ value }) => <TeamNameCell title={value} img={undefined} />,
            },
            {
                field: 'role',
                headerName: 'Role',
                flex: 1,
                minWidth: 100,
                renderCell: ({ value }) => <RoleCell data={value} />,
            },
            {
                field: 'members',
                headerName: 'Members',
                flex: 1,
                minWidth: 100,
                renderCell: ({ value }) => <MembersCell data={value} />,
            },
            {
                field: 'actions',
                width: 40,
                renderCell: ({ row }) => (
                    <ActionCell>
                        <MenuItem
                            icon={<BiBarChartAlt2 />}
                            as={Link}
                            to={ROUTES.team.fullPath + '/' + row.id + '/variables'}
                        >
                            Variable customization
                        </MenuItem>
                        <MenuDivider marginY="4px" />
                        <InviteMemberDialog
                            title={row.title}
                            trigger={<MenuItem icon={<TbUserPlus />}>Invite member</MenuItem>}
                            teamId={row.id}
                            companyId={row.companyId}
                        />
                        <EditTeamNameDialog title={row.title} id={row.id} />
                        <DeleteTeamDialog title={row.title} id={row.id} />
                    </ActionCell>
                ),
                // renderCell: ({ row }) => {
                //     return row.status !== 'deleted' && <ModalDeleteApiKey id={row.id} preview={row.preview} />;
                // },
            },
        ],
        [],
    );
    const handleClick = (row: any) => navigate('/admin/team/' + row.id);

    return <Table columns={columns} rows={teams} rowClick={handleClick} />;
};

export default TeamTable;
